import React from 'react';

const DigitalBackground = () => {
  return (
    <svg 
      className="absolute inset-0 w-full h-full z-0" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1440 800" 
      preserveAspectRatio="xMidYMid slice"
    >
      {/* Dark sky background */}
      <rect width="100%" height="100%" fill="#222" />
      
      {/* Stars */}
      {Array.from({ length: 100 }).map((_, i) => (
        <circle 
          key={`star-${i}`} 
          cx={Math.random() * 1440} 
          cy={Math.random() * 400} 
          r={Math.random() * 1.5} 
          fill="#fff" 
          opacity={Math.random() * 0.8 + 0.2} 
        />
      ))}
      
      {/* Aurora Borealis Effect */}
      <defs>
        {/* Radial Gradients for Aurora */}
        {/* Violet to Transparent */}
        <radialGradient id="auroraGradient1" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#A0F" stopOpacity="1" />
          <stop offset="100%" stopColor="#A0F" stopOpacity="0" />
        </radialGradient>
        {/* Blue to Transparent */}
        <radialGradient id="auroraGradient2" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#39F" stopOpacity="1" />
        <stop offset="100%" stopColor="#39F" stopOpacity="0" />
        </radialGradient>
         {/* Light Blue to Transparent */}
        <radialGradient id="auroraGradient3" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#00BFFF" stopOpacity="1" />
          <stop offset="100%" stopColor="#00BFFF" stopOpacity="0" />
        </radialGradient>
        {/* Light Violet to Transparent */}
        <radialGradient id="auroraGradient4" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#DDA0DD" stopOpacity="1" />
          <stop offset="100%" stopColor="#DDA0DD" stopOpacity="0" />
        </radialGradient>
         {/* Violet/Blue Mix to Transparent */}
        <radialGradient id="auroraGradient5" cx="50%" cy="50%" r="70%">
          <stop offset="0%" stopColor="#9370DB" stopOpacity="1" />
          <stop offset="50%" stopColor="#ADD8E6" stopOpacity=".5" />
          <stop offset="100%" stopColor="#9370DB" stopOpacity="0" />
        </radialGradient>
      </defs>
      
     {/* Aurora paths - top portion of the sky with various paths */}
     {Array.from({ length: 15 }).map((_, i) => {
          const gradientId = `auroraGradient${(i % 3) + 1}`;
          const path = `M${Math.random() * 1440},${Math.random() * 300} Q${Math.random() * 1440},${Math.random() * 300} ${Math.random() * 1440},${Math.random() * 300}`;
          const strokeWidth = Math.random() * 30 + 20; // Random stroke width
          return (
            <path 
              key={`aurora-${i}`}
              d={path} 
              stroke={`url(#${gradientId})`}
              strokeWidth={strokeWidth} 
              opacity="0.3"
            />
          );})}
       {/* Aurora paths - top portion of the sky with various paths */}
      {Array.from({ length: 15 }).map((_, i) => {
          const gradientId = `auroraGradient${(i % 5) + 1}`;
          const path = `M${Math.random() * 1440},${Math.random() * 300} Q${Math.random() * 1440},${Math.random() * 300} ${Math.random() * 1440},${Math.random() * 300}`;
          const strokeWidth = Math.random() * 30 + 20; // Random stroke width
          return (
            <path 
              key={`aurora-${i}`}
              d={path} 
              stroke={`url(#${gradientId})`}
              strokeWidth={strokeWidth} 
              opacity="0.3"
            />
          );})}
      {/* Distant mountains - taller on edges, lower in middle */}
      <path 
        d="M0,800 L0,400 L200,420 L400,450 L600,500 L720,550 L800,580 L880,550 L1000,500 L1200,450 L1440,400 L1440,800 Z" 
        fill="#1a2030" 
      />
      
      {/* Middle mountains - with slight blue tint */}
      <path 
        d="M0,800 L0,450 L240,470 L480,500 L600,530 L720,580 L800,600 L880,580 L1000,530 L1200,500 L1440,450 L1440,800 Z" 
        fill="#1a1a2e" 
      />
      
      {/* Foreground mountains - with more detail and valley in the middle */}
      <path 
        d="M0,800 L0,500 L160,520 L320,540 L480,560 L600,580 L720,650 L800,670 L880,650 L1000,580 L1160,560 L1320,540 L1440,500 L1440,800 Z" 
        fill="#191930" 
      />
      
      {/* Mountain accents */}
      <path 
        d="M0,500 L160,520 L320,540" 
        stroke="#39F" 
        strokeWidth="1" 
        opacity="0.4" 
        fill="none" 
      />
      
      <path 
        d="M480,560 L600,580" 
        stroke="#A0F" 
        strokeWidth="1" 
        opacity="0.4" 
        fill="none" 
      />
      
      <path 
        d="M880,650 L1000,580 L1160,560" 
        stroke="#39F" 
        strokeWidth="1" 
        opacity="0.4" 
        fill="none" 
      />
      
      <path 
        d="M1320,540 L1440,500" 
        stroke="#A0F" 
        strokeWidth="1" 
        opacity="0.4" 
        fill="none" 
      />
      
      {/* Cloud shapes - positioned above the wordmark area (top 30% of screen) */}
      <g opacity="1">
      {/* Large fluffy cloud 1 */}
        <path
          d="M100,100 Q180,50 260,80 Q320,70 380,80 Q450,70 520,80 Q580,70 640,80 L640,100 Q560,130 460,110 Q380,140 280,120 Q180,150 100,100 Z"
          fill="#333333"
        />

        {/* Large fluffy cloud 2 */}
        <path
          d="M800,80 Q880,30 960,60 Q1020,50 1080,60 Q1150,50 1220,60 Q1280,50 1340,60 L1340,80 Q1260,110 1160,90 Q1080,120 980,100 Q880,130 800,80 Z"
          fill="#2a2a2a"
        />

        {/* Large fluffy cloud 3 */}
        <path
          d="M300,150 Q380,100 460,120 Q520,100 580,120 Q650,100 720,120 Q780,100 840,130 L840,150 Q760,180 660,160 Q580,190 480,170 Q380,200 300,150 Z"
          fill="#3a3a3a"
        />

        {/* Additional fluffy cloud 4 */}
        <path
          d="M900,120 Q980,70 1060,90 Q1120,80 1180,90 Q1250,80 1320,90 Q1380,80 1440,100 L1440,120 Q1360,150 1260,130 Q1180,160 1080,140 Q980,170 900,120 Z"
          fill="#404040"
        />

        {/* Additional fluffy cloud 5 */}
        <path
          d="M100,50 Q180,0 260,30 Q320,20 380,30 Q450,20 520,30 Q580,20 640,30 L640,50 Q560,80 460,60 Q380,90 280,70 Q180,100 100,50 Z"
          fill="#353535"
        />

        {/* Additional fluffy cloud 6 */}
        <path 
          d="M500,100 Q580,20 660,50 Q720,0 780,40 Q850,10 920,50 Q980,30 1040,80 Q960,130 860,110 Q780,140 680,120 Q580,150 500,100 Z" 
          fill="#2d2d2d" 
        />
        {/* Large cloud 7 - Left edge */}
        <path d="M-50,100 Q50,-20 150,30 Q200,-40 250,0 Q300,-30 350,20 Q400,-10 450,30 Q400,80 300,60 Q200,90 100,70 Q0,100 -50,100 Z" fill="#303030" />
        {/* Large cloud 7 - Left edge */}
        <path d="M-50,200 Q50,100 150,150 Q200,100 250,120 Q300,100 350,120 Q400,100 450,120 L450,200 Q400,180 300,160 Q200,190 100,170 Q0,200 -50,200 Z" fill="#282828" />
        {/* Large cloud 8 - Right edge */}
        <path d="M1490,100 Q1390,-20 1290,30 Q1240,-40 1190,0 Q1140,-30 1090,20 Q1040,-10 990,30 Q1040,80 1140,60 Q1240,90 1340,70 Q1440,100 1490,100 Z" fill="#353535" />
        <path d="M1490,200 Q1390,100 1290,150 Q1240,100 1190,120 Q1140,100 1090,120 Q1040,100 990,120 L990,200 Q1040,180 1140,160 Q1240,190 1340,170 Q1440,200 1490,200 Z" fill="#2b2b2b" />
        {/* Smaller cloud 9 - Random position */}
        <path d="M700,50 Q750,10 800,40 Q850,10 900,50 Q850,80 750,60 Q650,90 600,70 Q650,50 700,50 Z" fill="#383838" />

        {/* Smaller cloud details - more rounded elements */}
        <circle cx="200" cy="80" r="60" fill="#404040" />
        <circle cx="300" cy="60" r="70" fill="#383838" />
        <circle cx="400" cy="90" r="80" fill="#454545" />
        
        <circle cx="900" cy="70" r="60" fill="#404040" />
        <circle cx="1000" cy="50" r="70" fill="#383838" />
        <circle cx="1100" cy="80" r="80" fill="#454545" />
        
        <circle cx="400" cy="130" r="60" fill="#404040" />
        <circle cx="500" cy="110" r="70" fill="#383838" />
        <circle cx="600" cy="140" r="80" fill="#454545" />
        
        <circle cx="1000" cy="100" r="65" fill="#3d3d3d" />
        <circle cx="1100" cy="80" r="75" fill="#424242" />
        <circle cx="1200" cy="110" r="85" fill="#3a3a3a" />
        
        <circle cx="200" cy="30" r="55" fill="#3d3d3d" />
        <circle cx="300" cy="10" r="65" fill="#424242" />
        <circle cx="400" cy="40" r="75" fill="#3a3a3a" />
        
        <circle cx="600" cy="60" r="50" fill="#3d3d3d" />
        <circle cx="700" cy="40" r="60" fill="#424242" />
        <circle cx="800" cy="70" r="70" fill="#3a3a3a" />
      </g>
    </svg>
  );
};

export default DigitalBackground;